var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 10C7.8 10 6.9 9.8 6.2 9.3C5.5 8.8 4.8 8.3 4.4 7.5C4 6.7 3.7 5.9 3.7 5C3.7 4.1 3.9 3.2 4.4 2.5C4.9 1.8 5.4 1.1 6.2 0.7C7 0.3 7.8 0 8.7 0C9.6 0 10.5 0.2 11.2 0.7C11.9 1.2 12.6 1.7 13 2.5C13.4 3.3 13.7 4.1 13.7 5C13.7 5.9 13.5 6.8 13 7.5C12.5 8.2 12 8.9 11.2 9.3C10.4 9.7 9.6 10 8.7 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 11.2C12.7 11 14 11.4 14.8 11.9C15.6 12.4 16.2 13 16.7 13.8C17.2 14.6 17.4 15.5 17.4 16.4V18C17.4 18.5 17.2 19 16.9 19.3C16.6 19.6 16.1 20 15.6 20H1.8C1.3 20 0.8 19.8 0.5 19.5C0.2 19.2 0 18.7 0 18.2V16.6C0 15.7 0.2 14.8 0.7 14C1.2 13.2 1.8 12.6 2.6 12.1C3.4 11.6 4.3 11.4 5.2 11.4H5.9C6.8 11.8 7.8 12 8.8 12C9.8 12 11.2 11.6 11.7 11.4L12.2 11.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.7c2a8006f405e14582481265973e736c.svg";
export { ForwardRef as ReactComponent };